// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_component_OfflineScreen_index_js":"9236c1a963e608260f4f","vendors-node_modules_date-io_date-fns_build_index_esm_js-node_modules_material-ui_core_esm_Av-a27de2":"bcb104766c842ed1acd0","src_view_EventViewer_js":"8747404f4a7b1f39bb52","src_wrapper_HTMLWrapper_js":"026b49b87264aab1058d"}[chunkId] + ".js";
};